// import React from "react";
// import { Route, Routes } from "react-router-dom";
// import { authProtectedRoutes, publicRoutes } from "./allRoutes";
// import Layout from "Layout";
// import NonAuthLayout from "Layout/NonLayout";
// import AuthProtected from "./AuthProtected";
// import PermissionSegment from "Common/Components/PermissionLocks/PermissionSegment";
// import { permissionData } from "slices/auth/login/reducer";
// import { useSelector, useDispatch } from "react-redux";
// import { createSelector } from "reselect";

// const RouteIndex = () => {
//   // todo const { permissions } = useSelect();
//   // const permissions = ["role:read"];
//   const selectProperties = createSelector(
//     (state: any) => state.Login,
//     (profile) => ({
//       permission: profile.permission,
//     })
//   );

//   const { permission } = useSelector(selectProperties);
//   console.log(permission)
//   return (
//     <React.Fragment>
//       <Routes>
//         {authProtectedRoutes.map((route: any, idx: number) => (
//           <Route
//             key={idx}
//             path={route.path}
//             element={
//               <AuthProtected>
//                 <Layout>
//                   {(() => {
//                     const hasAllPermissions = route.permissions
//                       ? route.permissions.every((perm: string) =>
//                         permission.permissions?.includes(perm)
//                       )
//                       : true;

//                     return (
//                       <PermissionSegment
//                         text={""}
//                         shouldHavePermissions={route.permissions ?? []}
//                         hasPermissions={permission.permissions ?? []}
//                         className={null}
//                       >
//                         {hasAllPermissions ? <route.component /> : <></>}
//                       </PermissionSegment>
//                     );
//                   })()}
//                 </Layout>
//               </AuthProtected>
//             }
//           />
//         ))}

//         {publicRoutes.map((route: any, idx: number) => (
//           <Route
//             path={route.path}
//             key={idx}
//             element={
//               <NonAuthLayout>
//                 <route.component />
//               </NonAuthLayout>
//             }
//           />
//         ))}
//       </Routes>

//     </React.Fragment>
//   );
// };

// export default RouteIndex;


import React from "react";
import { Route, Routes } from "react-router-dom";
import { authProtectedRoutes, publicRoutes } from "./allRoutes";
import Layout from "Layout";
import NonAuthLayout from "Layout/NonLayout";
import AuthProtected from "./AuthProtected";
import PermissionSegment from "Common/Components/PermissionLocks/PermissionSegment";
import { permissionData } from "slices/auth/login/reducer";
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";

const RouteIndex = () => {
  console.log("🔵 RouteIndex RENDER");
  
  const selectProperties = createSelector(
    (state: any) => state.Login,
    (profile) => ({
      permission: profile.permission,
    })
  );

  const { permission } = useSelector(selectProperties);
  console.log("🔐 RouteIndex - Current permissions:", permission);
  
  return (
    <React.Fragment>
      <Routes>
        {authProtectedRoutes.map((route: any, idx: number) => (
          <Route
            key={idx}
            path={route.path}
            element={
              <AuthProtected>
                <Layout>
                  {(() => {
                    const hasAllPermissions = route.permissions
                      ? route.permissions.every((perm: string) =>
                        permission.permissions?.includes(perm)
                      )
                      : true;

                    return (
                      <PermissionSegment
                        text={""}
                        shouldHavePermissions={route.permissions ?? []}
                        hasPermissions={permission.permissions ?? []}
                        className={null}
                      >
                        {hasAllPermissions ? <route.component /> : <></>}
                      </PermissionSegment>
                    );
                  })()}
                </Layout>
              </AuthProtected>
            }
          />
        ))}

        {publicRoutes.map((route: any, idx: number) => (
          <Route
            path={route.path}
            key={idx}
            element={
              <NonAuthLayout>
                <route.component />
              </NonAuthLayout>
            }
          />
        ))}
      </Routes>
    </React.Fragment>
  );
};

export default RouteIndex;